import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuotePanelComponent } from './quote-panel.component';
import { QuoteModule } from './quote/quote.module';

@NgModule({
  declarations: [QuotePanelComponent],
  exports: [QuotePanelComponent],
  imports: [
    CommonModule,
    QuoteModule
  ],
})
export class QuotePanelModule {}